import { render, staticRenderFns } from "./originalTicket.vue?vue&type=template&id=3490ecee&"
import script from "./originalTicket.vue?vue&type=script&lang=js&"
export * from "./originalTicket.vue?vue&type=script&lang=js&"
import style0 from "./originalTicket.vue?vue&type=style&index=0&id=3490ecee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports